import React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { DAY_START, DAY_END, STEP, toHHMM, fmtHours } from './utils';

const thumbCls = 'block h-8 w-8 -mt-0 rounded-full border-2 border-white bg-[#3b2508] shadow-lg cursor-grab active:cursor-grabbing focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 touch-none';

export function TimeRangeSlider({ value, onChange, colour = '#3b2508', min = DAY_START, max = DAY_END }) {
  const [s, e] = value;
  return (
    <div className="space-y-3" data-testid="time-range-slider">
      <div className="flex items-end justify-between">
        <div><div className="text-[11px] uppercase tracking-wider text-gray-500 font-bold">Start</div><div className="text-2xl font-black tabular-nums" data-testid="time-range-start">{toHHMM(s)}</div></div>
        <div className="text-sm font-semibold text-gray-600 pb-1" data-testid="time-range-duration">{fmtHours(e - s)}</div>
        <div className="text-right"><div className="text-[11px] uppercase tracking-wider text-gray-500 font-bold">End</div><div className="text-2xl font-black tabular-nums" data-testid="time-range-end">{toHHMM(e)}</div></div>
      </div>
      <SliderPrimitive.Root
        value={value}
        min={min}
        max={max}
        step={STEP}
        minStepsBetweenThumbs={1}
        onValueChange={onChange}
        className="relative flex w-full touch-none select-none items-center py-3"
        aria-label="Time range"
      >
        <SliderPrimitive.Track className="relative h-3 w-full grow overflow-hidden rounded-full bg-gray-200">
          <SliderPrimitive.Range className="absolute h-full rounded-full" style={{ background: colour }} />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className={thumbCls} style={{ background: colour }} aria-label="Start time" data-testid="time-range-thumb-start" />
        <SliderPrimitive.Thumb className={thumbCls} style={{ background: colour }} aria-label="End time" data-testid="time-range-thumb-end" />
      </SliderPrimitive.Root>
      <div className="flex justify-between text-[10px] text-gray-400 font-mono">
        {[6, 8, 10, 12, 14, 16, 18, 20, 22].map((h) => <span key={h}>{h}</span>)}
      </div>
    </div>
  );
}
